/* LaBosch Mobile UX v78 */
(function(){
  'use strict';

  var mq=window.matchMedia('(max-width:1024px)');
  if(!mq.matches) return;

  function qs(root,sel){return (root||document).querySelector(sel);}
  function isHidden(el){
    if(!el) return true;
    return el.hidden || el.getAttribute('aria-hidden')==='true' || getComputedStyle(el).display==='none';
  }
  function text(el){return el?String(el.textContent||'').replace(/\s+/g,' ').trim():'';}

  function initStoreModal(root){
    var panel=qs(root,'[data-lbx-store-stock-panel]');
    var trigger=panel&&qs(panel,'.lbx-store-stock-chip__trigger');
    var list=panel&&qs(panel,'[data-lbx-store-stock-list]');
    if(!panel||!trigger||!list||trigger.dataset.lbx78Ready==='1') return;
    trigger.dataset.lbx78Ready='1';

    var modal=document.createElement('div');
    modal.className='lbx78-store-modal';
    modal.setAttribute('aria-hidden','true');
    modal.innerHTML=''+
      '<button type="button" class="lbx78-store-modal__backdrop" data-lbx78-store-close aria-label="Cerrar"></button>'+
      '<section class="lbx78-store-modal__sheet" role="dialog" aria-modal="true" aria-label="Disponibilidad por tienda">'+
        '<div class="lbx78-store-modal__handle" aria-hidden="true"></div>'+
        '<div class="lbx78-store-modal__head">'+
          '<span><strong>Disponibilidad por tienda</strong><small data-lbx78-store-summary></small></span>'+
          '<button type="button" class="lbx78-store-modal__close" data-lbx78-store-close aria-label="Cerrar">×</button>'+
        '</div>'+
        '<div class="lbx78-store-modal__list" data-lbx78-store-list></div>'+
      '</section>';
    root.appendChild(modal);

    var modalList=qs(modal,'[data-lbx78-store-list]');
    var modalSummary=qs(modal,'[data-lbx78-store-summary]');
    var lastFocus=null;

    function sync(){
      modalList.innerHTML=list.innerHTML;
      var count=list.querySelectorAll('.lbx-store-stock__row').length;
      modalSummary.textContent=count===1?'1 tienda con stock':count+' tiendas con stock';
    }
    function open(){
      if(isHidden(panel)) return;
      sync();
      lastFocus=document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden','false');
      document.body.classList.add('lbx78-store-modal-open');
      var close=qs(modal,'.lbx78-store-modal__close');
      if(close) setTimeout(function(){close.focus();},20);
    }
    function close(){
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden','true');
      document.body.classList.remove('lbx78-store-modal-open');
      if(lastFocus&&lastFocus.focus) lastFocus.focus();
    }

    trigger.addEventListener('click',function(e){
      e.preventDefault();
      e.stopPropagation();
      open();
    },true);
    modal.querySelectorAll('[data-lbx78-store-close]').forEach(function(btn){btn.addEventListener('click',close);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&modal.classList.contains('is-open'))close();});

    var mo=new MutationObserver(sync);
    mo.observe(list,{childList:true,subtree:true,characterData:true});
  }

  function initStickyBuy(root){
    if(qs(root,'.lbx78-sticky-buy')) return;
    var buyButton=qs(root,'[data-lbx-buy-button]');
    var purchase=buyButton&&buyButton.closest('.lbx-purchase-actions');
    var preorderRoot=qs(root,'[data-lbx-preorder-root]');
    var preorderOpen=qs(root,'[data-lbx-preorder-open]');
    var price=qs(root,'[data-lbx-price]')||qs(root,'[data-lbx-price-mobile]');
    var variantInput=qs(root,'[data-lbx-variant-id]');
    if(!buyButton||!purchase) return;

    var sticky=document.createElement('div');
    sticky.className='lbx78-sticky-buy';
    sticky.setAttribute('aria-hidden','true');
    sticky.innerHTML=''+
      '<div class="lbx78-sticky-buy__copy">'+
        '<strong class="lbx78-sticky-buy__price" data-lbx78-sticky-price></strong>'+
        '<span class="lbx78-sticky-buy__meta" data-lbx78-sticky-meta></span>'+
      '</div>'+
      '<button type="button" class="lbx78-sticky-buy__button" data-lbx78-sticky-action></button>';
    document.body.appendChild(sticky);

    var stickyPrice=qs(sticky,'[data-lbx78-sticky-price]');
    var stickyMeta=qs(sticky,'[data-lbx78-sticky-meta]');
    var action=qs(sticky,'[data-lbx78-sticky-action]');
    var purchaseVisible=true;
    var pastHero=false;

    function reserveActive(){
      return !!(preorderRoot && !isHidden(preorderRoot) && preorderOpen && root.classList.contains('has-lbx-reserve-only'));
    }
    function sync(){
      var reserve=reserveActive();
      var buyLabel=text(qs(buyButton,'[data-lbx-buy-text]'))||text(buyButton)||'Comprar ahora';
      var reserveLabel=preorderOpen?text(preorderOpen):'Reservar ahora';
      var deposit=qs(root,'[data-lbx-preorder-title]');
      var currentPrice=text(qs(price,'[data-lbx-price-current]'))||text(qs(price,'[data-lbx-price-current-mobile]'))||text(price);
      stickyPrice.textContent=(reserve&&deposit&&text(deposit))?text(deposit):currentPrice;
      stickyMeta.textContent=reserve?'Reserva esta eBike':'Compra rápida · selección actual';
      action.textContent=reserve?reserveLabel:buyLabel;
      action.disabled=reserve?false:buyButton.disabled;
      sticky.classList.toggle('is-reserve',reserve);
      updateVisibility();
    }
    function modalOpen(){
      return document.body.classList.contains('lbx78-store-modal-open') ||
             document.body.classList.contains('lbx-preorder-modal-open') ||
             document.body.classList.contains('lbx-wishlist-modal-open');
    }
    function updateVisibility(){
      var show=pastHero && !purchaseVisible && !modalOpen();
      sticky.classList.toggle('is-visible',show);
      sticky.setAttribute('aria-hidden',show?'false':'true');
      document.body.classList.toggle('lbx78-sticky-active',show);
    }

    action.addEventListener('click',function(){
      if(reserveActive()){
        preorderOpen.click();
      }else if(!buyButton.disabled){
        buyButton.click();
      }
    });

    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){purchaseVisible=entry.isIntersecting;updateVisibility();});
      },{threshold:.1});
      io.observe(purchase);
    }else{
      purchaseVisible=false;
    }

    function onScroll(){
      pastHero=window.scrollY>Math.min(360,window.innerHeight*.42);
      updateVisibility();
    }
    window.addEventListener('scroll',onScroll,{passive:true});
    onScroll();

    var mo=new MutationObserver(sync);
    mo.observe(root,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','disabled','hidden','aria-hidden','value']});
    if(variantInput) variantInput.addEventListener('change',sync);
    root.addEventListener('click',function(e){if(e.target.closest('[data-lbx-option-button]'))setTimeout(sync,40);});
    sync();
  }

  function init(){
    document.querySelectorAll('.lbx-product-pro').forEach(function(root){
      initStoreModal(root);
      initStickyBuy(root);
    });
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
